// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__AVgsd"};